import Vue from 'vue'
import adminUserApi from '@/api/adminUser'
import store from '@/store/index'
import { replaceUserInList } from '@/utils/userUtils'
import { INVOICE_ID_MAX } from '@/consts/user'

export const useInvoiceId = () => {
  const canEditInvoiceId = () => {
    return store.getters['user/isStaffTypeManager']
  }

  const initializeInvoiceIdInputState = (user) => {
    Vue.set(user, 'input_invoice_id', false)
    Vue.set(user, 'input_invoice_id_val', null)
  }

  const switchToInputModeInvoiceId = (user) => {
    user.input_invoice_id = true
    user.input_invoice_id_val = user.invoice_id
  }

  const switchToNonInputModeInvoiceId = (user) => {
    user.input_invoice_id = false
    user.input_invoice_id_val = null
  }

  const isValidInvoiceIdInput = (value) => {
    return Number.isInteger(value) && value >= 1 && value <= INVOICE_ID_MAX
  }

  const updateInvoiceId = async(users, idx, user) => {
    if (!isValidInvoiceIdInput(user.input_invoice_id_val)) {
      alert(`請求書IDは1以上${INVOICE_ID_MAX}以下の整数を入力してください。`)
      return
    }

    const obj = { invoice_id: user.input_invoice_id_val }
    try {
      await adminUserApi.updateInvoiceId(user.id, obj)
      user.invoice_id = obj.invoice_id
      replaceUserInList(users, idx, user)
      switchToNonInputModeInvoiceId(user)
    } catch (error) {
      console.error(error)
    }
  }

  return {
    canEditInvoiceId,
    initializeInvoiceIdInputState,
    switchToInputModeInvoiceId,
    switchToNonInputModeInvoiceId,
    updateInvoiceId,
  }
}
